import React, { useState } from "react";
import { Box, Flex, FormLabel, HStack, Input, Text } from "@chakra-ui/react";
// import icon from "../assets/logo.png";
import { BsCalendar2Day } from "react-icons/bs";
import dayjs from "dayjs";

const DateField = ({ text, width, date, setDate, handleSearch }) => {
  const [inputOpacity, setInputOpacity] = useState("0");
  return (
    <Flex
      width={width || "48%"}
      justify={"space-between"}
      align="center"
      color="#140236"
      borderRadius={"35px"}
    >
      <Text mr="10px">{text}:</Text>
      <HStack
        justifyContent={"space-between"}
        width="100%"
        bg="#ECECEE"
        borderRadius={"35px"}
        p="7px"
        px="15px"
      >
        <Text>{dayjs().format("DD/MM/YYYY")}</Text>
        <FormLabel width={"100%"} htmlFor="profile-pic">
          {" "}
          <BsCalendar2Day color="#5E6CE7" />
        </FormLabel>
        <Box position={"absolute"} opacity={inputOpacity} zIndex={100}>
          <Input
            marginLeft="-26px"
            id="profile-pic"
            width={"100%"}
            bg="#ECECEE"
            color="#5D5D5E"
            borderRadius={"35px"}
            type="date"
            value={date}
            onChange={(e) => {
              setInputOpacity("1");
              setDate(e.target.value);
              handleSearch(e)
            }}
          />
        </Box>
      </HStack>
    </Flex>
  );
};

export default DateField;
